import { render, staticRenderFns } from "./PrivacyAndPolicy.vue?vue&type=template&id=0b6e7cfa&scoped=true"
import script from "./PrivacyAndPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyAndPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyAndPolicy.vue?vue&type=style&index=0&id=0b6e7cfa&prod&lang=scss&scoped=true"
import style1 from "./PrivacyAndPolicy.vue?vue&type=style&index=1&id=0b6e7cfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6e7cfa",
  null
  
)

export default component.exports